var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mintage __form_border" },
    [
      _c("div", { staticClass: "item" }, [
        _c("div", { staticClass: "__form_input_title" }, [
          _vm._v(_vm._s(_vm.$t("walletMintage.address")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "__form_input unuse" }, [
          _vm._v(_vm._s(_vm.activeAddr))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "span",
              {
                staticClass: "__form_tips",
                class: { active: _vm.tipsType === "tokenName" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.tipsType === "tokenName"
                        ? _vm.$t("walletMintage.hint.tokenName")
                        : ""
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "__form_input_title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletMintage.tokenName")) +
                  "\n                "
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tokenNameErr,
                      expression: "tokenNameErr"
                    }
                  ],
                  staticClass: "err"
                },
                [_vm._v(_vm._s(_vm.tokenNameErr))]
              )
            ]),
            _vm._v(" "),
            _c("vite-input", {
              attrs: { valid: _vm.isTokenName },
              on: {
                blur: _vm.hideTips,
                focus: function($event) {
                  return _vm.showTips("tokenName")
                }
              },
              model: {
                value: _vm.tokenName,
                callback: function($$v) {
                  _vm.tokenName = $$v
                },
                expression: "tokenName"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "span",
              {
                staticClass: "__form_tips",
                class: { active: _vm.tipsType === "tokenSymbol" }
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      _vm.tipsType === "tokenSymbol"
                        ? _vm.$t("walletMintage.hint.tokenSymbol")
                        : ""
                    ) +
                    "\n            "
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "__form_input_title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletMintage.tokenSymbol")) +
                  "\n                "
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tokenSymbolErr,
                      expression: "tokenSymbolErr"
                    }
                  ],
                  staticClass: "err"
                },
                [_vm._v(_vm._s(_vm.tokenSymbolErr))]
              )
            ]),
            _vm._v(" "),
            _c("vite-input", {
              attrs: { valid: _vm.isTokenSymbol },
              on: {
                blur: _vm.hideTips,
                focus: function($event) {
                  return _vm.showTips("tokenSymbol")
                }
              },
              model: {
                value: _vm.tokenSymbol,
                callback: function($$v) {
                  _vm.tokenSymbol = $$v
                },
                expression: "tokenSymbol"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "__form_input_title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletMintage.decimals")) +
                  "\n                "
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.decimalsErr,
                      expression: "decimalsErr"
                    }
                  ],
                  staticClass: "err"
                },
                [_vm._v(_vm._s(_vm.decimalsErr))]
              )
            ]),
            _vm._v(" "),
            _c("vite-input", {
              on: {
                blur: _vm.hideTips,
                focus: function($event) {
                  return _vm.showTips("decimals")
                }
              },
              model: {
                value: _vm.decimals,
                callback: function($$v) {
                  _vm.decimals = $$v
                },
                expression: "decimals"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item right" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "__form_input_title" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("walletMintage.totalSupply")) +
                  "\n                "
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.totalSupplyErr,
                      expression: "totalSupplyErr"
                    }
                  ],
                  staticClass: "err"
                },
                [_vm._v(_vm._s(_vm.totalSupplyErr))]
              )
            ]),
            _vm._v(" "),
            _c("vite-input", {
              model: {
                value: _vm.totalSupply,
                callback: function($$v) {
                  _vm.totalSupply = $$v
                },
                expression: "totalSupply"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row" },
          [
            _c("div", { staticClass: "__form_input_title" }, [
              _vm._v(_vm._s(_vm.$t("walletMintage.isReIssuable")))
            ]),
            _vm._v(" "),
            _c("bool-radio", {
              model: {
                value: _vm.isReIssuable,
                callback: function($$v) {
                  _vm.isReIssuable = $$v
                },
                expression: "isReIssuable"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isReIssuable,
                expression: "isReIssuable"
              }
            ],
            staticClass: "row"
          },
          [
            _c(
              "div",
              { staticClass: "half" },
              [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("walletMintage.maxSupply")) +
                      "\n                    "
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.maxSupplyErr,
                          expression: "maxSupplyErr"
                        }
                      ],
                      staticClass: "err"
                    },
                    [_vm._v(_vm._s(_vm.maxSupplyErr))]
                  )
                ]),
                _vm._v(" "),
                _c("vite-input", {
                  model: {
                    value: _vm.maxSupply,
                    callback: function($$v) {
                      _vm.maxSupply = $$v
                    },
                    expression: "maxSupply"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "half" },
              [
                _c("div", { staticClass: "__form_input_title" }, [
                  _vm._v(_vm._s(_vm.$t("walletMintage.isOwnerBurnOnly")))
                ]),
                _vm._v(" "),
                _c("bool-radio", {
                  model: {
                    value: _vm.ownerBurnOnly,
                    callback: function($$v) {
                      _vm.ownerBurnOnly = $$v
                    },
                    expression: "ownerBurnOnly"
                  }
                })
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.canMintage,
                expression: "canMintage"
              }
            ],
            staticClass: "__form_btn __pointer",
            on: { click: _vm.toMintage }
          },
          [_vm._v(_vm._s(_vm.$t("walletMintage.mint")))]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.canMintage,
                expression: "!canMintage"
              }
            ],
            staticClass: "__form_btn __pointer unuse"
          },
          [_vm._v(_vm._s(_vm.$t("walletMintage.mint")))]
        )
      ]),
      _vm._v(" "),
      _vm.tokenInfo
        ? _c("mintage-confirm", {
            attrs: {
              tokenInfo: _vm.tokenInfo,
              close: _vm.closeConfirm,
              clear: _vm.clearAll
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }